<template>
  <div class="exchange_info">
    <h3>전환 정보</h3>
    <dl>
      <dt>포인트 종류</dt>
      <dd>{{ pointInfo.pointName }}</dd>
    </dl>
    <dl>
      <dt>전환할 포인트</dt>
      <dd>
        {{ addComma(exchangeRequest.point) }}
        {{ pointInfo.pointUnitName }}
      </dd>
    </dl>
    <dl>
      <dt>전환 금액</dt>
      <dd>
        <strong>{{ addComma(exchangeRequest.amount) }} 원 (세전)</strong>
      </dd>
    </dl>
  </div>
</template>

<script>
import mixin from '@/utils/mixin';
import { mapGetters, mapActions } from 'vuex';

export default {
  mixins: [mixin],
  computed: {
    ...mapGetters('point', ['pointInfo']),
    ...mapGetters('exchange', ['exchangeRequest']),
  },
  methods: {
    ...mapActions('point', ['getPointInfo']),
  },
  async created() {
    await this.getPointInfo();
  },
};
</script>
<style lang="scss">
strong {
  font-weight: bold;
}
</style>
